export default __webpack_public_path__ + "static/media/blob.b911e4f9.svg";